import { makeImmutable } from "../../core";
import { CustomParameterMultiSet } from "./CustomParameterMultiSet";
import { InternalParameterMultiSet } from "./InternalParameterMultiSet";
import { ScheduleParameterMultiSet } from "./ScheduleParameterMultiSet";
export class ParameterMultiSet {
    constructor(params) {
        this.internal = params.internal;
        this.custom = params.custom;
        this.schedule = params.schedule;
        makeImmutable(this);
    }
    static empty() {
        return new ParameterMultiSet({
            internal: InternalParameterMultiSet.empty(),
            custom: CustomParameterMultiSet.empty(),
            schedule: ScheduleParameterMultiSet.empty(),
        });
    }
    union(other) {
        return new ParameterMultiSet({
            internal: this.internal.union(other.internal),
            custom: this.custom.union(other.custom),
            schedule: this.schedule.union(other.schedule),
        });
    }
    intersection(other) {
        return new ParameterMultiSet({
            internal: this.internal.intersection(other.internal),
            custom: this.custom.intersection(other.custom),
            schedule: this.schedule.intersection(other.schedule),
        });
    }
}
